import { createContext, useContext } from "react";

/**
 * Lets any component (TopBar search, ProfileMenu shortcut, etc.) open the
 * global command palette without prop-drilling. App.tsx owns the open state
 * and provides the context.
 */
export type CommandPaletteApi = { open: () => void };

export const CommandPaletteContext = createContext<CommandPaletteApi | null>(null);

export function useCommandPalette(): CommandPaletteApi {
  const ctx = useContext(CommandPaletteContext);
  return ctx ?? { open: () => {} };
}
